import request from "../utils/request.js";
import qs from 'qs';
export function getModelList(queryParams) {
  if(queryParams && Object.keys(queryParams).length > 0){
    const queryString = qs.stringify(queryParams);
    return request({
      url: `/model/list?${queryString}`,
      method: 'GET',
    });
  }else{
    return request({
      url: `/model/list`,
      method: 'GET',
    });
  }
}

export function updateModel(param) {
  return request({
    url: `/model/update`,
    method: 'PATCH',
    data: param
  });
}

export function getModelSwitchLog({ pageNum, pageSize }) {
  return request({
    url: `/model/switch-log/list`,
    method: 'GET',
    params: { pageNum, pageSize }
  });
}
